import db from 'src/lib/dexie-db/db';
import { NodeType } from 'src/modules/exam-preparation/graphql/common/types/node';
import { getSafeData } from './utils';
const EFAPIs = {
    async getForQuestion(userID, questionID) {
        const ef = await db.qnaNode
            .where('ancestors')
            .equals(questionID)
            .and(node => node.type === NodeType.WRITTEN_EF &&
            !node.deleted)
            .first();
        return ef ? getSafeData(ef) : null;
    },
    getSafeData,
};
export default EFAPIs;
